import { animate, state, style, transition, trigger } from '@angular/animations';

export const collapse = trigger('collapse', [
  state(
    'collapsed',
    style({
      height: 0,
      overflow: 'hidden',
      border: 0,
      marginBottom: 0,
      opacity: 0,
    }),
  ),
  state(
    'normal',
    style({
      height: '*',
      opacity: 1,
    }),
  ),
  // immediate change state from none state to collapsed
  transition('void <=> collapsed', animate('0ms')),
  transition('* <=> collapsed', animate('200ms ease-in-out')),
  transition('collapsed <=> normal', animate('200ms ease-in-out')),
]);

export enum CollapseState {
  Collapsed = 'collapsed',
  Normal = 'normal',
}
